import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { useEffect, useState,useRef } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import { Card, Modal } from "react-bootstrap";
import {useDispatch,useSelector } from 'react-redux';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useForm } from "react-hook-form"
import { fetchDataEvent,ViewNotificationDetailsValue,getCustomer,clearCustomerDetails } from './stateManegement/dispatch';

export default function ViewNotificationDetails({userData}) {
  const [errorsMasterValue, setErrorsMasterValue] = useState({});
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm()
  const [isCusmerNum, setisCusmerNum] = useState(false);
  const [customerNumber, setCustomerNumber] = useState('');
  const [selectedDate1, setSelectedDate1] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [calenderTwoState, setCalenderTwoState] = useState(true)
  const [starEndDateCheck,setStarEndDateCheck] = useState(false)
  const datepickerRef1 = useRef(null);  // Reference for the first DatePicker
  const datepickerRef2 = useRef(null);  // Reference for the second DatePicker
  const dispatch = useDispatch();
  const { loading, customerData,eventData,customerTableData,apierror } = useSelector((state) => state.connectionReducer);

  const tableRef = useRef();

  const downloadTable = () => {
    const tableHTML = tableRef?.current?.outerHTML?.replace(/ /g, '%20');
    const filename = 'table_data.xls';

    const dataType = 'application/vnd.ms-excel';
    const downloadLink = document.createElement('a');

    document.body.appendChild(downloadLink);

    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    downloadLink.download = filename;
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  useEffect(() => {
    dispatch(fetchDataEvent(userData));
    
  }, [dispatch]);
  useEffect(()=>{
    dispatch(clearCustomerDetails(userData))
  },[])
  const handleSubmitForm = (data) => {

    if (!data.toStart || !data.toEnd) {
      setStarEndDateCheck(true)
      return; // Prevent further submission if dates are missing
    }
    if(data.customerNumber.length === 0 ){
      setisCusmerNum(true)
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Optional for smooth scrolling
      });
      // Add your submit logic here (e.g., send data to an API)
    }else{
      dispatch(ViewNotificationDetailsValue(userData, data))
      .then(() => {
        //  window.alert("Cusomer details get successfully!");
      })
      .catch((error) => {
        console.error("An error occurred:", error);
      });
    }
   
  };

  useEffect(()=>{
    if (selectedDate1 !== null) {
      const date = new Date(selectedDate1);
      date.setDate(date.getDate() + 1); // Increase date by 1
      setSelectedDate2(date)
      setValue('toEnd', moment(date).format("DD-MM-YY")); 
      setCalenderTwoState(false);
    }
  },[selectedDate1])
   // Generic function to handle focus based on the ref passed
   const handleIconClick = (datepickerRef) => {
    
     if (datepickerRef.current) {
       datepickerRef.current.setFocus();
     }
   };
   
  const validateForm = () => {
    const newErrors = {};
    // if (!newTariffFormData?.TariffName) newErrors.TariffName = 'Tariff Name is required';
    // if (!newTariffFormData?.TariffDescription) newErrors.TariffDescription = 'Tariff Description is required';
    // if (!newTariffFormData?.TariffServiceCategory) newErrors.TariffServiceCategory = 'Tariff Service Category is required';
    // if (!newTariffFormData?.TariffServiceTypeCategory) newErrors.TariffServiceTypeCategory = 'Tariff Service Type Category is required';
    // if (!newTariffFormData?.TariffSubCategoryCategory) newErrors.TariffSubCategoryCategory = 'Tariff Sub Category Category is required';
    // if (!newTariffFormData?.TariffFixedUnit) newErrors.TariffFixedUnit = 'Tariff Fixed Unit is required';
    // if (!newTariffFormData?.TariffFixedSubsidy) newErrors.TariffFixedSubsidy = 'Tariff Fixed Subsidy is required';
    // if (!newTariffFormData?.TariffFixedCharges) newErrors.TariffFixedCharges = 'Tariff Fixed Charges is required';
    // if (!newTariffFormData?.TariffFixedMinimumCharges) newErrors.TariffFixedMinimumCharges = 'Tariff Minimum Charges is required';
    // if (!newTariffFormData?.TariffFixedMaximumCharges) newErrors.TariffFixedMaximumCharges = 'Tariff Maximum Charges is required';
    return newErrors;
  };
  const handleInputChange = (e) => {
    const consumerNum = e.target.value;
    setCustomerNumber(consumerNum);
    if(e.target.value.length < 0){
      setisCusmerNum(true)
    }else{
      setisCusmerNum(false)
    }
   
    if (consumerNum.length > 4) {
      // Use setTimeout to delay the dispatch
      setTimeout(() => {
        dispatch(getCustomer(userData, consumerNum));
      }, 1000); // 1000 milliseconds delay (1 second)
    }
  };
 
  useEffect(() => {
    // Initialize form values if needed)
   
    setValue("meterId", customerData?.pDATASET?.[0]?.METER_ID || '');
    setValue("customerNumber", customerNumber);
    setValue("customerId",customerData?.pDATASET?.[0]?.CUSTOMER_ID || "")
    setValue("customer_name",customerData?.pDATASET?.[0]?.CUSTOMER_NAME || "")
    setValue("meterNumber",customerData?.pDATASET?.[0]?.METER_NO || "")
    setValue("eventData",eventData?.pDATASET?.[0]?.EVENT_TYPE_ID || '')

  }, [customerData, customerNumber, setValue]);
  return (
    <>
      <Card
        style={{ 
          height: "auto",
          width: "100%",
          backgroundColor: "#17234D",
          borderRadius: "0px",
        }}
      >
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
              fontFamily: "Roboto-Regular",
              fontSize: "25px",
            }}
          >
           View Notification Details
          </Card.Title>
        </Card.Body>
      </Card>
      <Card
        style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", margin: "30px" }}
      >
        <Card.Body
          style={{ maxHeight: "65vh", overflowY: "auto", paddingBottom: "5%" }}
        >
          <>
            {" "}
            <Container>
              <Form onSubmit={handleSubmit(handleSubmitForm)}>
              <Card style={{ borderWidth: 0, height: '60px', width: '100%', backgroundColor: '#FFF6D6', borderRadius: '0px' }}>
            <Container style={{ paddingTop: '10px', }}>
              <Row>
                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>State</Col>
                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Distict</Col>
                
              </Row>
              <Row>
              <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>
                    <input className="inputHide" defaultValue={userData.pDATASET[0].STATE_NAME} />
                  </Col>
                  <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}>
                    <input className="inputHide" defaultValue={userData.pDATASET[0].CIRCLE_NAME} />
                  </Col>
              </Row> </Container> </Card>
          
                <Row className="mb-3">
                <Col sm={3}>
                    <Form.Group>
                      <Form.Label><span className="req">*</span>Event Type</Form.Label>
                      <Form.Select aria-label="Default select example" {...register("eventName")}>
                                                    {eventData?.pDATASET?.map(service => (
                              <option key={service.EVENT_TYPE_ID} value={service.EVENT_TYPE_ID}>
                                {service.EVENT_NAME}
                              </option>
                            ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col sm={3}>
                  <Form.Label><span className="req">*</span>From Date</Form.Label>
                    <Form.Group className="mb-3" controlId="formGroupEmail">
                     
                      <DatePicker
                        ref={datepickerRef1}
                        selected={selectedDate1}           // Selected date for the first date picker
                        onChange={(date) =>{ 
                          setStarEndDateCheck(false)
                          setSelectedDate1(date)
                          setValue('toStart', moment(date).format("DD-MM-YY"));
                        }} // Function to update the date
                        dateFormat="yyyy/dd/MM"         // Date format
                        placeholderText="Select a date" // Placeholder text                   // Option to clear the selected date
                       
                        showYearDropdown                // Show dropdown to select year
                        scrollableYearDropdown          // Make year dropdown scrollable
                        icon={<img src={require('../../assets/calender.png')} style={{ paddingLeft: '10px', right: 5, width: 20, height: 20 }} onClick={() => handleIconClick(datepickerRef1)}  />}
                        showIcon
                        // minDate={new Date()}
                      />
                      <input type='hidden'  value={selectedDate1} {...register("toStart")} />
                    </Form.Group>
                  </Col>
                  <Col sm={3}>
                  <Form.Label><span className="req">*</span>To Date</Form.Label>
                  <Form.Group className="mb-3" controlId="formGroupEmail">
                      
                      <DatePicker
                        ref={datepickerRef2}
                        selected={selectedDate2}  
                        startDate={selectedDate1}         // Selected date for the second date picker
                        onChange={(date) => {
                          setSelectedDate2(date)
                          setValue('toEnd', moment(date).format("DD-MM-YY")); 
                        }} // Function to update the date
                        dateFormat="yyyy/dd/MM"         // Date format
                        placeholderText="Select a date" // Placeholder text                   // Option to clear the selected date
                        showYearDropdown
                     
                        minDate={new Date(selectedDate2)}
                                      // Show dropdown to select year
                        scrollableYearDropdown          // Make year dropdown scrollable
                        disabled={calenderTwoState}
                        icon={<img src={require('../../assets/calender.png')} style={{ paddingLeft: '10px', right: 5, width: 20, height: 20 }} onClick={() =>handleIconClick(datepickerRef2)}  />}
                        showIcon
                      />
                    </Form.Group>
                    <input type='hidden' value={selectedDate2} {...register("toEnd")}   />
                   
                  </Col>
                  {starEndDateCheck && (
                    <span style={{ color: "red" }}>Please Select From and To Date</span>
                  )}
                 
                </Row>
                <Row className="mb-3">
              <Col sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label><span className="req">*</span>Consumer no :{" "}</Form.Label>
                  <Form.Control
                    {...register("customerNumber")} // Register the input with react-hook-form
                    value={customerNumber}
                    onChange={handleInputChange}
                    type="text"
                    placeholder="Consumer no"
                  
                  />
                   {/* errors will return when field validation fails  */}
                   {isCusmerNum && (
                    <span style={{ color: "red" }}>This field required</span>
                  )}
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Id : </Form.Label>
                  <Form.Control
                    type="text"
                    value={customerData?.pDATASET?.[0]?.CUSTOMER_ID || ""}
                    placeholder="Consumer Id"
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Name: </Form.Label>
                  <Form.Control
                    type="text"
                    value={customerData?.pDATASET?.[0]?.CUSTOMER_NAME || ""}
                    placeholder="Consumer name"
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row>

            <hr />           
            <Row className="mb-3" >
            
              <Col sm={4}>
                <Form.Group>
                  <Form.Label>Meter No</Form.Label>
                  <Form.Select  disabled={customerData?.pDATASET?.length >= 0 ? false : true } aria-label="Default select example">
                  {customerData?.pDATASET?.map((item, index) => (
                    <option className="tableOption" key={index} value={item.METER_NO || ""}>
                      {item.METER_NO || ""}
                    </option>
                  ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Meter Id</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={true}
                    value={customerData?.pDATASET?.[0]?.METER_ID || ''}
                  />
                </Form.Group>
              </Col>
            </Row>

                <hr />

                <div style={{ marginTop: 40, marginLeft: "10px" }}>
                <div className="btn_div">
            <button className="btn btn-primary" type="button" onClick={() => { reset(()=>{
              dispatch(clearCustomerDetails(userData))
              setCustomerNumber("")
              setSelectedDate2(null)
              setSelectedDate1(null)
              setisCusmerNum(false)
      
            }); }}>
              Clear All
            </button>
              <input className="btn btn-primary" type="submit" value="SUBMIT" />
            </div>
                </div>
              </Form>
            </Container>
            <hr></hr>
            <Container>
            {customerTableData === undefined ? <div style={{ textAlign: 'center', fontSize: '15px' }}>No Records Found!!</div> : null}
          <table border="1" className={customerTableData?.pDATASET === undefined && 0 ? "d-none" : ""}>
            <thead>
            <tr>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">CONSUMER NO</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">METER NO</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">EVENT DATA</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">EVENT NAME</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">DEVICES STATUS</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">CURRENT BALANCE</th> 
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">ACTION STATUS</th>
              
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">REMARKS</th>
                <th style={{ backgroundColor: "#FFF6D6" }} width="200">TARIFF ID</th>
              </tr>
            </thead>
            <tbody>
            {customerTableData?.pDATASET?.map((item, index) => (
                <tr key={index}>
                  <td>{item.CONSUMERNO}</td> {/* Example Action Flag */}
                  <td>{item.METERNO}</td> {/* Example Current Balance */}
                  <td>{item.EVENT_DATE}</td> {/* Example Remarks */}
                  <td>{item.EVENT_NAME}</td> {/* Example Event DateTime */}
                  <td>{item.DEVICE_STATUS}</td> {/* Example Event DateTime */}
                  <td>{item.CURRENT_BALANCE_VALUE}</td> {/* Example Event DateTime */}
                  <td>{item?.ACTION_STATUS || "No Comment"}</td> {/* Example Event DateTime */}
                  <td>{item?.REMARKS || "No Comment"}</td>
                  {/* <td>{item?.COMMENTS || "No Comment"}</td> Example Event DateTime */}
                  <td>{item.TARIFF_ID}</td> {/* Example Event DateTime */}
                </tr>
              ))}
            </tbody>
          </table>
              <hr></hr>
              <Form >
                <Row className="mb-3">
               
                  <Col sm={4}>
                    <div style={{ marginTop: 30, marginLeft: "10px" }}>
                      {/* <Button variant="primary" type="submit">
                                    Cancel
                                </Button> */}

                      <Button variant="primary" onClick={downloadTable}>Download</Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Container>
          </>
        </Card.Body>
      </Card>
    </>
  );
}
